var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleFillPlusBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_74876",
    "data-name": "Group 74876",
    transform: "translate(-754 -582)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    transform: "translate(754 582)",
    fill: "#fff",
    stroke: "#0f4c7d",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1794",
    "data-name": "Rectangle 1794",
    transform: "translate(760.808 586.539)",
    fill: "#fff",
    stroke: "#0f4c7d",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.513,
    height: 6.052,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 0.513,
    height: 5.052,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1795",
    "data-name": "Rectangle 1795",
    transform: "translate(764.59 588.808) rotate(90)",
    fill: "#fff",
    stroke: "#0f4c7d",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.513,
    height: 6.052,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 0.513,
    height: 5.052,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleFillPlusBlue);
export default __webpack_public_path__ + "static/media/CircleFillPlusBlue.0987d85698238f597d039f5b46e2bc74.svg";
export { ForwardRef as ReactComponent };